import React from "react";

// Components
import Table from "../Table";
import { Button } from "antd";
import { ColumnProps } from "antd/es/table";
import { PlusOutlined } from "@ant-design/icons";

// Hooks
import { useHistory } from "react-router";
import { FetchCarrierQuery, fetchCarriers } from "../../../../../api/logistics/carrier";
import { useQuery } from "react-query";
import { isEmpty } from "lodash-es";

interface CarriersTableProps {
  query: FetchCarrierQuery;
}

const CarriersTable: React.FC<CarriersTableProps> = ({ query }) => {
  const history = useHistory();
  const organizationID = query.organization_id;
  const carriers = useQuery(["carriers", query], () => fetchCarriers(query), {
    enabled: !isEmpty(query),
  });

  const headerButtons = [
    <Button
      key="Add Carrier"
      onClick={(): void => {
        history.push(`/organizations/${organizationID}/carriers/create`);
      }}
      icon={<PlusOutlined />}
    >
      Add Carrier
    </Button>,
  ];

  const getColumns = (): ColumnProps<any>[] => {
    const renderServiceCodes = (serviceCodes: string[]) => {
      return serviceCodes
        ? serviceCodes.map((serviceCode: string, index: number) =>
            index === serviceCodes.length - 1 ? `${serviceCode}` : `${serviceCode}, `
          )
        : null;
    };

    return [
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "Carrier Code",
        dataIndex: "carrier_code",
        key: "carrier_code",
      },
      {
        title: "External ID",
        dataIndex: "external_id",
        key: "external_id",
      },
      {
        title: "External Platform",
        dataIndex: "external_platform",
        key: "external_platform",
      },
      {
        title: "Service Codes",
        dataIndex: "enabled_service_codes",
        key: "enabled_service_codes",
        render: renderServiceCodes,
      },
    ];
  };

  const tableProps = {
    columns: getColumns(),
    dataSource: carriers.data,
    loading: carriers.isLoading,
  };

  return (
    <div className="fulfillment-table">
      <Table
        headerButtons={organizationID ? headerButtons : null}
        tableProps={tableProps}
        title="Carriers"
        fullListLink={organizationID ? `/organizations/${organizationID}/carriers` : null}
      />
    </div>
  );
};

export default CarriersTable;
